import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { Header, ConnectCard } from "../../Components";
import { AdjustTrove, Trove } from "../../PageComponents/Borrow";

export type BorrowProps = {
  disconnected?: boolean;
};

// const selector = ({ trove }: LiquityStoreState) => ({
//   trove
// });

const Borrow: React.FC<BorrowProps> = ({ disconnected = false }) => {
  return (
    <Box>
      <Header title="borrow.png" />
      <Flex direction="column" flex={1} mt={6}>
        <Flex flex={1}>
          <Trove disconnected={disconnected} />
        </Flex>
        <Flex flex={1} mt={6}>
          {disconnected ? (
            <ConnectCard title="Create Trove" />
          ) : (
            <AdjustTrove disconnected={disconnected} />
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default Borrow;
